import i18next from 'i18next';

export const documents_select_types = [
	{ name: i18next.t('common:none'), value: '' }
];
